import * as React from 'react'
import { IContextProvider } from '../../uxp';
import { extractPath, IWDDesignModeProps, PropertyPath } from '../common/common';
import { IDataSource } from '../common/data-source-picker/datasource';
import { ISelectableItemUIProp } from '../common/SelectableItem';
import { IContextData } from '../../hooks/useContextData';

interface IPropertyPanelProps {
    props: ISelectableItemUIProp[];
    onChange: (id: PropertyPath, value: any) => void;
    uiProps: any;
    uxpContext?: IContextProvider,
    contextData: IContextData,
    designer: IWDDesignModeProps,
    selectedContainer?: string,
    elementId?: string,
    isMobile?: boolean
}

const PropertyPanel: React.FunctionComponent<IPropertyPanelProps> = (props) => {
    let itemProps = props.props || [];
    return <div className='wd-property-panel'>
        {
            itemProps.map(ip => {
                const customProps: any = {}
                if (ip.customProps) {
                    for (const k of Object.keys(ip.customProps)) {
                        customProps[k] = extractPath(props.uiProps, ip.customProps[k], props.isMobile, props.elementId)
                    }
                }

                let x = ip.definition.render({
                    uiProps: extractPath(props.uiProps, ip.id, props.isMobile, props.elementId) || ip.definition.defaults,
                    onChange: (up) => {
                        // let updatedValues = Object.assign({},ip.value||{},up);
                        let updatedValues = up;
                        props.onChange(ip.id, updatedValues);
                    },
                    onChangeAny: (path, value) => {
                        props.onChange(path, value);
                    },
                    uxpContext: props.uxpContext,
                    contextData: props.contextData,
                    designer: props.designer,
                    parentUIProps: props.uiProps,
                    containerId:props.selectedContainer,
                }, props.uxpContext, props.contextData, props.selectedContainer || '', customProps);
                return x;
            })
        }
    </div>;
}

export default PropertyPanel